import { useNavigate } from 'react-router-dom';
import { DollarSign, ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';
import { useTranslation } from '@/utils/i18n';

function RefundPolicy() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-gray-400 hover:text-[#ff6b35] transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          {t('backToHome')}
        </button>

        <div className="flex items-center gap-3 mb-6">
          <DollarSign className="w-8 h-8 text-[#ff6b35]" />
          <h1 className="text-4xl font-bold gradient-text">{t('refundPolicy')}</h1>
        </div>

        <div className="bg-[#1a1a1a] border border-[#ff6b35]/20 rounded-xl p-8 space-y-6">
          <div className="space-y-6 text-gray-300 leading-relaxed">
            <h2 className="text-xl font-semibold text-white">{t('refundTitle')}</h2>
            
            <p>{t('refundText1')}</p>

            <div className="bg-[#ff6b35]/10 border border-[#ff6b35]/30 rounded-lg p-6">
              <p className="font-semibold text-[#ff6b35]">{t('refundNoRefunds')}</p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-white mb-3">{t('refundException')}</h3>
              <p>{t('refundBillingError')}</p>
            </div>

            <p className="text-sm">
              {t('refundContactText')} <a href="mailto:support@donotbull.com" className="text-[#ff6b35] hover:underline">support@donotbull.com</a>
            </p>
          </div>

          <div className="pt-6 border-t border-gray-800">
            <p className="text-sm text-gray-400">
              {t('lastUpdated')} {new Date().toLocaleDateString(language === 'fr' ? 'fr-FR' : language === 'es' ? 'es-ES' : 'en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RefundPolicy;